import React, { useState } from 'react';
import { ISystemMail_has_Dictionary } from '../../Interfaces/ISystemMail_has_Dictionary';
import { IDictionary } from '../../Interfaces/IDictionary';
import { IDictionaryEntry } from '../../Interfaces/IDictionaryEntry';
import {
  Card,
  CardContent,
  Checkbox,
  Collapse,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { DictionaryEdit } from '../DictionaryEdit';
import { Edit, Search } from '@mui/icons-material';
import { useAlert } from '../../context/AlertContext';
import {
  useCreateSystemMailHasDictionary,
  useDeleteSystemMailHasDictionary,
} from '../../hooks/reactQuerys/SystemMailQueries';

interface IProps {
  idSystemMail: number;
  systemMailHasDictionaryArray: ISystemMail_has_Dictionary[];
  dictionaries: IDictionary[];
  dictionaryEntries: IDictionaryEntry[];
  refetchDictionary: () => void;
  refetchDictionaryEntry: () => void;
  refetchSystemMailHasDictionary: () => void;
}

export const SystemMailDialogAdmin: React.FC<IProps> = ({
  idSystemMail,
  systemMailHasDictionaryArray,
  dictionaries,
  dictionaryEntries,
  refetchDictionary,
  refetchDictionaryEntry,
  refetchSystemMailHasDictionary,
}) => {
  const { showAlert } = useAlert();

  const {
    createSystemMailHasDictionary,
    isPendingCreateSystemMailHasDictionary,
  } = useCreateSystemMailHasDictionary();
  const {
    deleteSystemMailHasDictionary,
    isPendingDeleteSystemMailHasDictionary,
  } = useDeleteSystemMailHasDictionary();
  const isPending =
    isPendingCreateSystemMailHasDictionary ||
    isPendingDeleteSystemMailHasDictionary;

  const selectedDictionaries = systemMailHasDictionaryArray
    .filter(smHasDict => smHasDict.idSystemMail === idSystemMail)
    .map(smHasDict => smHasDict.idDictionary);

  const [editDictionary, setEditDictionary] = useState<IDictionary | null>(
    null
  );

  const onWriteHasDictionary = async (
    uploadObject: ISystemMail_has_Dictionary
  ) => {
    try {
      await createSystemMailHasDictionary(uploadObject);
      showAlert({
        text: 'Erfolgreich gespeichert!',
        severity: 'success',
      });
      refetchSystemMailHasDictionary();
    } catch (error) {
      console.error(error);
      showAlert({
        text: 'Es ist ein Fehler aufgetretten!',
        severity: 'error',
      });
    }
  };

  const onDeleteHasDictionary = async (
    uploadObject: ISystemMail_has_Dictionary
  ) => {
    try {
      await deleteSystemMailHasDictionary(uploadObject);
      showAlert({
        text: 'Erfolgreich gelöscht!',
        severity: 'success',
      });
      refetchSystemMailHasDictionary();
    } catch (error) {
      console.error(error);
      showAlert({
        text: 'Es ist ein Fehler aufgetretten!',
        severity: 'error',
      });
    }
  };

  return (
    <Grid item xs={7}>
      <Card variant='outlined'>
        <CardContent>
          <Typography sx={{ mb: 2 }}>
            Administrative Darstellung: Änderungen werden sofort gespeichert
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <>Wörterbücher</>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Wörterbuch</TableCell>
                    <TableCell width={50}>Aktionen</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dictionaries.map(dict => (
                    <TableRow key={`dict-select-${dict.idDictionary}`}>
                      <TableCell>
                        <Checkbox
                          checked={selectedDictionaries.includes(
                            dict.idDictionary
                          )}
                          onChange={e => {
                            if (e.target.checked) {
                              onWriteHasDictionary({
                                idSystemMail: idSystemMail,
                                idDictionary: dict.idDictionary,
                              });
                            } else {
                              onDeleteHasDictionary({
                                idSystemMail: idSystemMail,
                                idDictionary: dict.idDictionary,
                              });
                            }
                          }}
                        />{' '}
                      </TableCell>
                      <TableCell>{dict.Dictionary}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => setEditDictionary(dict)}>
                          <Edit />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>

            <Grid item xs={6}>
              {editDictionary ? (
                <DictionaryEdit
                  editDictionary={editDictionary}
                  setEditDictionary={setEditDictionary}
                  dictionaryEntries={dictionaryEntries}
                  refetchDictionary={refetchDictionary}
                  refetchDictionaryEntry={refetchDictionaryEntry}
                  enableInstantSave
                />
              ) : (
                <>Wählen Sie ein Wörterbuch</>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
